define(["require", "exports", "ts-vector-math", "../Shared/Helper"], function (require, exports, ts_vector_math_1, Helper_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var BoundingBox2D = (function () {
        function BoundingBox2D(center, size) {
            this.m_Center = new ts_vector_math_1.Vector2([center.x, center.y]);
            this.m_Extents = size.scale(0.5, ts_vector_math_1.Vector2.zero);
        }
        Object.defineProperty(BoundingBox2D.prototype, "center", {
            get: function () { return new ts_vector_math_1.Vector2([this.m_Center.x, this.m_Center.y]); },
            set: function (value) { this.m_Center = new ts_vector_math_1.Vector2([value.x, value.y]); },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(BoundingBox2D.prototype, "size", {
            get: function () { return this.m_Extents.scale(2.0, ts_vector_math_1.Vector2.zero); },
            set: function (value) { this.m_Extents = value.scale(0.5, this.m_Extents); },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(BoundingBox2D.prototype, "extents", {
            get: function () { return new ts_vector_math_1.Vector2([this.m_Extents.x, this.m_Extents.y]); },
            set: function (value) { this.m_Extents = new ts_vector_math_1.Vector2([value.x, value.y]); },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(BoundingBox2D.prototype, "min", {
            get: function () { return this.center.subtract(this.extents, ts_vector_math_1.Vector2.zero); },
            set: function (value) { this.SetMinMax(value, this.max); },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(BoundingBox2D.prototype, "max", {
            get: function () { return this.center.add(this.extents, ts_vector_math_1.Vector2.zero); },
            set: function (value) { this.SetMinMax(this.min, value); },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(BoundingBox2D.prototype, "width", {
            get: function () { return this.max.x - this.min.x; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(BoundingBox2D.prototype, "height", {
            get: function () { return this.max.y - this.min.y; },
            enumerable: true,
            configurable: true
        });
        BoundingBox2D.prototype.SetMinMax = function (min, max) {
            this.extents = (max.subtract(min, this.extents)).scale(0.5, this.extents);
            this.center = min.add(this.extents, this.center);
        };
        BoundingBox2D.prototype.GrowByPoint = function (point) {
            var newVec = new ts_vector_math_1.Vector2([point.x, point.y]);
            this.SetMinMax(Helper_1.Helper.Vector2.Min(this.min, newVec), Helper_1.Helper.Vector2.Max(this.max, newVec));
        };
        BoundingBox2D.prototype.Grow = function (bounds) {
            this.GrowByPoint(bounds.center.subtract(bounds.extents, ts_vector_math_1.Vector2.zero));
            this.GrowByPoint(bounds.center.add(bounds.extents, ts_vector_math_1.Vector2.zero));
        };
        BoundingBox2D.prototype.Intersects = function (bounds) {
            if ((this.min.x <= bounds.max.x) && (this.max.x >= bounds.min.x) &&
                (this.min.y <= bounds.max.y) && (this.max.y >= bounds.min.y))
                return true;
            return false;
        };
        BoundingBox2D.GetEncapsulatedBounds = function (boundingBoxes) {
            if (boundingBoxes.length == 0)
                return null;
            var boundingBox = new BoundingBox2D(boundingBoxes[0].center, boundingBoxes[0].size);
            for (var _i = 0, boundingBoxes_1 = boundingBoxes; _i < boundingBoxes_1.length; _i++) {
                var bO = boundingBoxes_1[_i];
                boundingBox.Grow(bO);
            }
            return boundingBox;
        };
        return BoundingBox2D;
    }());
    exports.BoundingBox2D = BoundingBox2D;
});
//# sourceMappingURL=BoundingBox2D.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/Shared/BoundingBox2D.js
// module id = 104
// module chunks = 0